export default __webpack_public_path__ + "static/media/vip7.5a5ca77f.gif";